import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

const ItalianFlag: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 60 30" preserveAspectRatio="xMidYMid meet">
    <rect width="20" height="30" fill="#009246" />
    <rect width="20" height="30" x="20" fill="#fff" />
    <rect width="20" height="30" x="40" fill="#ce2b37" />
  </SvgIcon>
);

export default ItalianFlag;
